import * as types from "./actionTypes";

// eslint-disable-next-line import/prefer-default-export
export const submitUmbrellaDeclarationForm = (formContent) => ({
  type: types.SUBMIT_UMBRELLA_DECLARATION_FORM,
  payload: { formContent },
});
